<template>
    <div class="mui-c-tag mui-border-solid mui-background">
        <slot />
    </div>
</template>

<style lang="scss">
    .mui-c-tag {
        width: max-content;
        padding: var(--joy-core-spacing-1) var(--joy-core-spacing-2);
        color: var(--mui-color-text);
        font-weight: var(--joy-font-weight-bold);
        letter-spacing: var(--joy-font-letter-spacing-tight);
        font-size: var(--joy-font-size-primary-400);
    }
</style>
